import {
    Star,
    Clock3,
    Store,
    Leaf,
    Drumstick,
    CheckCircle2,
    XCircle,
    Flame,
    Sparkles,
} from "lucide-react";
import getImageUrl from "../../../utils/imageUrl";
import "./FoodHero.css";

function FoodHero({ food }) {
    const imageUrl = food.image
    ? getImageUrl(food.image)
    : "/images/food-placeholder.png";
    return (
        <div className="food-hero">

            <div className="food-hero-image">

               <img
    src={imageUrl}
    alt={food.foodName}
    onError={(e) => {
        e.currentTarget.src =
            "/images/food-placeholder.png";
    }}
/>

            </div>

            <div className="food-hero-content">

                <div className="food-title-row">

                    <h1>{food.foodName}</h1>

                    <div className="food-status">

                        {food.isAvailable ? (
                            <span className="badge available">
                                <CheckCircle2 size={14} />
                                Available
                            </span>
                        ) : (
                            <span className="badge unavailable">
                                <XCircle size={14} />
                                Unavailable
                            </span>
                        )}

                        {food.isFeatured && (
                            <span className="badge featured">
                                <Star size={14} />
                                Featured
                            </span>
                        )}

                        {food.isBestSeller && (
                            <span className="badge bestseller">
                                <Flame size={14} />
                                Best Seller
                            </span>
                        )}

                        {food.isTodaysSpecial && (
                            <span className="badge special">
                                <Sparkles size={14} />
                                Today's Special
                            </span>
                        )}

                    </div>

                </div>

                <p className="food-description">
                    {food.description}
                </p>

                <div className="food-meta">

                    <div>

                        <Store size={18} />

                        <span>
                            {food.providerId?.businessName || "-"}
                        </span>

                    </div>

                    <div>

                        {food.foodType === "Veg"
                            ? <Leaf size={18} />
                            : <Drumstick size={18} />}

                        <span>{food.foodType}</span>

                    </div>

                    <div>

                        <Clock3 size={18} />

                        <span>
                            {food.preparationTime} mins
                        </span>

                    </div>

                    <div>

                        <Star size={18} />

                        <span>
                            {food.rating || 0}
                            {" "}
                            ({food.ratingCount || 0})
                        </span>

                    </div>

                </div>

                <div className="food-price-section">

                    <div className="price-card">

                        <label>Price</label>

                        <h2>₹{food.price}</h2>

                    </div>

                    <div className="price-card">

                        <label>Offer Price</label>

                        <h2>

                            {food.offerPrice
                                ? `₹${food.offerPrice}`
                                : "-"}

                        </h2>

                    </div>

                    <div className="price-card">

                        <label>Orders</label>

                        <h2>{food.totalOrders || 0}</h2>

                    </div>

                    <div className="price-card">

                        <label>Views</label>

                        <h2>{food.totalViews || 0}</h2>

                    </div>

                </div>

            </div>

        </div>
    );
}

export default FoodHero;